import { Badge, Group } from '@mantine/core';

export const FLOW_PROPOSAL_STATUSES = {
  pending: { label: 'Pending', color: 'yellow' },
  approved: { label: 'Approved', color: 'green' },
  rejected: { label: 'Rejected', color: 'red' },
  expired: { label: 'Expired', color: 'gray' },
  conflicted: { label: 'Conflicted', color: 'orange' },
};

const FlowProposalBadges = ({ proposal }) => (
  <Group gap={4} wrap="nowrap">
    <Badge variant="light" color={FLOW_PROPOSAL_STATUSES[proposal.status].color}>
      {FLOW_PROPOSAL_STATUSES[proposal.status].label}
    </Badge>
    {proposal.status === 'pending' && proposal.stale && (
      <Badge variant="light" color="orange">
        Stale
      </Badge>
    )}
  </Group>
);

export default FlowProposalBadges;
